export const MAIN_IMAGE_MIN_RATIO = 1.3;
export const MAIN_IMAGE_MAX_RATIO = 1.8;
export const LOGO_IMAGE_MIN_RATIO = 1;
export const LOGO_IMAGE_MAX_RATIO = 1.3;
export const DETAIL_IMAGE_MIN_RATIO = 1;
export const DETAIL_IMAGE_MAX_RATIO = 2.0;
export const DETAIL_IMAGE_TOTAL_PIXELS_ERROR = 480000;
export const DETAIL_IMAGE_TOTAL_PIXELS_WARNING = 1920000;
export const MAX_UPLOAD_IMAGES = 30;
